import React, { createContext, useContext, useState } from 'react'

type TrainStatus = 'idle' | 'uploading' | 'queued' | 'done'

interface TrainingContextType {
  trainFile: File | null
  trainStatus: TrainStatus
  setTrainFile: (file: File | null) => void
  setTrainStatus: (status: TrainStatus) => void
}

const TrainingContext = createContext<TrainingContextType | undefined>(undefined)

export function TrainingProvider({ children }: { children: React.ReactNode }) {
  const [trainFile, setTrainFile] = useState<File | null>(null)
  const [trainStatus, setTrainStatus] = useState<TrainStatus>('idle')

  return (
    <TrainingContext.Provider value={{ trainFile, trainStatus, setTrainFile, setTrainStatus }}>
      {children}
    </TrainingContext.Provider>
  )
}

export function useTraining() {
  const context = useContext(TrainingContext)
  if (!context) throw new Error('useTraining must be used within TrainingProvider')
  return context
}
